"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fin = void 0;
const OpenFin = require("./OpenFin");
const fin_1 = require("./api/fin");
const transport_1 = require("./transport/transport");
const mockEnvironment_1 = require("./environment/mockEnvironment");
const mockWire_1 = require("./transport/mockWire");
exports.fin = ((typeof window !== 'undefined' && (window === null || window === void 0 ? void 0 : window.fin)) ||
    (() => {
        const environment = new mockEnvironment_1.MockEnvironment();
        const transport = new transport_1.Transport(mockWire_1.MockWire, environment, {
            uuid: '',
            name: ''
        });
        return new fin_1.default(transport);
    })());
exports.default = OpenFin;
